"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

// All project specific translations
var Projects = {
  // ESN Management
  esn_management_login: {
    nl: "Meld je aan op OSN Management",
    fr: "Connectez-vous à OSN Management",
    en: "Log into OSN Management"
  },
  esn_management_description: {
    nl: "Met OSN Management kunt u alle gegevens van ondernemers op het Ondernemersnetwerk beheren, zoals openingstijden, advertenties, videotheek en meer.",
    fr: "Avec OSN Management, vous pouvez gérer toutes les données des entrepreneurs sur le Réseau Entrepreneurs, telles que les heures d'ouverture, la publicité, la vidéothèque, etc.",
    en: "With OSN Management, you can manage all the the entrepreneurs data of the Entrepreneurs Network such as opening hours, advertisement, video library and more."
  },
  most_privacy_friendly: {
    nl: /*#__PURE__*/_react["default"].createElement("h1", null, "Meest ", /*#__PURE__*/_react["default"].createElement("strong", null, "privacyvriendelijke"), " en relevante zoekresultaten van ", /*#__PURE__*/_react["default"].createElement("strong", null, "alle Belgische ondernemers")),
    fr: /*#__PURE__*/_react["default"].createElement("h1", null, "Le moteur de recherche ", /*#__PURE__*/_react["default"].createElement("strong", null, "le plus confidentiel"), " avec des r\xE9sultats adapter \xE0 votre recherche ", /*#__PURE__*/_react["default"].createElement("strong", null, "des entrepreneurs Belge")),
    en: /*#__PURE__*/_react["default"].createElement("h1", null, "Most ", /*#__PURE__*/_react["default"].createElement("strong", null, "privacy-friendly"), " and relevant search results ", /*#__PURE__*/_react["default"].createElement("strong", null, "of all Belgian entrepreneurs"))
  },
  logo_alt: {
    nl: "Logo Ondernemersnetwerk",
    fr: "Logo Reseau Entrepreneurs",
    en: "Logo Entrepreneursnetwork"
  }
};
var _default = Projects;
exports["default"] = _default;